// @flow
import * as CookieWorkerConstants from "../../Constants/Global/cookieWorkerConstants";

export function setTokenFromCookie(token: string): Object {
  return {
    type: CookieWorkerConstants.SET_TOKEN_FROM_COOKIE,
    payload: { token }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/CookieWorker/cookieworker.js